import React from "react";
import { Link, useNavigate } from "react-router-dom";
import hand from "../../assets/img/icons/Waving Hand Light Skin Tone.svg";
import message from "../../assets/img/icons/message-notif.svg";
import notif from "../../assets/img/icons/notification-status.svg";
import hamIcon from "../../assets/img/icons/icons8-menü-50.png";
import Button from "../shared/Button";
import moment from "jalali-moment";
import { useUserInfo } from "../../context/UserContext";
import { useAuth } from "../../context/authContext";

const UserPanelMenu = ({ showMenu }) => {
  let todayJalali = moment().locale("fa").format("D  MMMM  YYYY");
  //YYYY/MM/DD
  const { userinfo } = useUserInfo();
  const { token } = useAuth();
  const navigate = useNavigate();
  const goToCreate = () => {
    if (token) {
      if (
        userinfo.data.user.role === "ادمین" ||
        userinfo.data.user.role === "میزبان" ||
        userinfo.data.user.role === "سوپر ادمین"
      ) {
        navigate("/create");
      } else {
        navigate("/hosting");
      }
    } else {
      navigate("/register");
    }
  };
  return (
    <div className="">
      <div className="UserPanelMenu">
        <div className="UserPanelMenu__helloProfile">
          <h6>
            سلام {userinfo.data.user.full_name} عزیز
          </h6>
          <button
            className="responsive-button-icon mr-[20px]"
            onClick={() => showMenu(true)}
          >
            <img width={30} src={hamIcon} />
          </button>
          <img className="hand" src={hand} />
          <div className="hidden md:block">|</div>
          <p>
            {" "}امروز {todayJalali}
          </p>
        </div>

        <div>
          <div className="flex gap-[36px] ">
            <button>
              <img src={message} />
            </button>
            <button onClick={() => navigate("/user/notification")}>
              <img src={notif} />
            </button>
            <Button onClick={goToCreate} varient="primary">
              افزودن اقامتگاه
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserPanelMenu;
